export default "__VITE_ASSET__2306e404__"